<template>
  <div v-if="item">
    <fields-list :item="item" :fields="fields" />
    <div class="save-group">
      <button class="btn btn-warning btn-icon" @click="updateItem">
        <span class="ti-save"></span>{{ "save" | setText("Сохранить") }}
      </button>
    </div>
  </div>
</template>

<script>
import { cardUpdate, cardContent, pushLang } from "@/plugins/functions";

export default {
  data: () => ({
    cardLink: "users",
    cardSetLink: "users",
    item: null,
    fields: [
      // {
      //   type: "checkbox",
      //   key: "is_root",
      //   label: "Root пользователь",
      //   labelKey: "is_root",
      // },
      {
        type: "field",
        key: "name",
        label: "Полное имя",
      },
      {
        type: "mask",
        mask: "+998#########",
        key: "phone",
        label: "Номер телефона",
        default: "+998",
      },
      {
        type: "field",
        key: "email",
        label: "Email",
      },
      {
        type: "field",
        key: "password",
        label: "Пароль",
      },
      {
        label: "Роль",
        key: "role",
        labelKey: "role",
        type: "select",
        modal: "role",
        selectKey: "name",
      },
      {
        label: "Торговые точки",
        key: "shops",
        labelKey: "shops",
        type: "selects",
        modal: "shop",
        selectKey: "name",
      },
      {
        label: "Организация",
        key: "organizations",
        labelKey: "organizations",
        type: "selects",
        modal: "organization",
        selectKey: "name",
      },
    ],
  }),

  props: ["id"],
  async created() {
    // this.pushLang();
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    pushLang: pushLang,
    async updateItem() {
      let item = await this.cardUpdate(
        this.cardSetLink,
        this.item,
        this.fields
      );
      // if (item){
      //   this.item = item;
      // }
    },
  },
};
</script>
<style>
</style>
